import { ReactNode } from 'react';

import { Modal, ModalBody, ModalContent, ModalOverlay, useColorModeValue } from '@ecoinvent/ui';
import { ReactFlowProvider } from '@xyflow/react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  header?: ReactNode;
  children: ReactNode;
};

const GraphFullscreenModal = ({ isOpen, onClose, header, children }: Props) => {
  const modalBg = useColorModeValue('white', 'gray.800');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent m={0} borderRadius={0} h="100vh" bg={modalBg} display="flex" flexDirection="column">
        {header}
        <ModalBody p={0} flex={1} minH={0}>
          <ReactFlowProvider>{children}</ReactFlowProvider>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default GraphFullscreenModal;
